export type GoogleTestButtonProps = {
  onClick: () => void;
};

export const GoogleTestButton = ({ onClick }: GoogleTestButtonProps) => (
  <button
    id="google-test-continue-button"
    data-testid="google-test-continue-button"
    onClick={onClick}
  >
    Continue with Google
  </button>
);
